var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8.49996C13.6098 8.49996 13.8337 8.2761 13.8337 7.99996C13.8337 7.72382 13.6098 7.49996 13.3337 7.49996V8.49996ZM2.66699 7.49996C2.39085 7.49996 2.16699 7.72382 2.16699 7.99996C2.16699 8.2761 2.39085 8.49996 2.66699 8.49996V7.49996ZM7.50032 13.3333C7.50032 13.6094 7.72418 13.8333 8.00032 13.8333C8.27647 13.8333 8.50032 13.6094 8.50032 13.3333H7.50032ZM8.50032 2.66663C8.50032 2.39048 8.27647 2.16663 8.00032 2.16663C7.72418 2.16663 7.50032 2.39048 7.50032 2.66663H8.50032ZM13.3337 7.49996H8.00032V8.49996H13.3337V7.49996ZM8.00032 7.49996H2.66699V8.49996H8.00032V7.49996ZM8.50032 13.3333V7.99996H7.50032V13.3333H8.50032ZM8.50032 7.99996V2.66663H7.50032V7.99996H8.50032Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a22d2c33.svg";
export { ForwardRef as ReactComponent };